export const manifest = {
  screens: {
    scr_2etf1r: { name: "Homepage", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_84f6bf: { name: "Reader-to-Revenue Score", route: "/", state: {"isDiagnosticOpen":true}, position: {"x":1400,"y":0}, isDefaultRow: true },
  },
}
